import React from 'react';
import getStyles from './styles';
import { ProjectViewPage } from '../../../components';

const OneTNPage = () => {
  const styles = getStyles();
  return (
    <ProjectViewPage
      // heroTitle="A Feature-Rich App Built for"
      // heroGradientText="Networking and Navigation"
      infoLabel1="Client"
      infoLabel2="Services"
      infoLabel3="Deliverables"
      infoLabel4="Tech Stack"
      client="OneTN"
      services={['UX/UI Design', 'Full Stack Development']}
      deliverables={['Mobile Application', 'CMS Dashboard']}
      techStack={['React Native', 'Node.js', 'Express']}
      clientLogo="/images/startup-white.png"
      gradientTextStyle={styles.logoStyle}
      infoLabel5="Website"
      visitWebsite="Visit Site"
      website="https://www.onetn.in/"
      overviewTitle="Overview"
      // approachTitle="Approach"
      heroImage="/images/onetn-first.png"
      overviewImage="/images/onetn-first.png"
      approachImage="/images/onetn-full.jpeg"
      overviewDescription={[
        'OneTN is Tamil Nadu’s unified digital platform designed to seamlessly connect startups with various government schemes, initiatives, and support services under one roof. OneTN acts as a single access point for startups to explore, apply, and benefit from multiple government departments without the complexity of navigating separate systems.'
      ]}
      approachDescription={[
        'The platform simplifies and accelerates the journey of entrepreneurs by providing easy access to funding programs, incentives, policy benefits, mentorship, and infrastructure support. Whether a startup is in its early stage or scaling towards expansion, OneTN ensures that every entrepreneur can leverage Tamil Nadu’s robust support ecosystem to grow faster and more efficiently. It creates a transparent, efficient, and collaborative digital environment that connects startups, enablers, and policymakers toward a shared vision of economic growth.',
        'With OneTN, Tamil Nadu aims to unite its innovation ecosystem to achieve a One Trillion Dollar Economy by empowering startups, driving industrial transformation, and promoting inclusive development. By bridging the gap between innovators and institutions, the platform not only strengthens the state’s entrepreneurial fabric but also reinforces Tamil Nadu’s position as a national leader in innovation, investment, and sustainable growth. Unite to build a One Trillion Economy with OneTN.'
      ]}
      heroContainerStyle={styles.container}
      commonSectionStyle={styles.section}
      heroSectionStyle={styles.heroSection}
      heroGradientStyle={styles.heroGradient}
      heroGlow1Style={styles.heroGlow1}
      heroGlow2Style={styles.heroGlow2}
      heroGlow3Style={styles.heroGlow3}
      containerWrapperStyle={styles.containerWrapper}
      heroImageContainerStyle={styles.heroImageContainer}
      phoneContainerStyle={styles.phoneContainer}
      phoneGlowStyle={styles.phoneGlow}
      phoneShadowStyle={styles.phoneShadow}
      heroPhoneStyle={styles.heroPhone}
      heroContentStyle={styles.heroContent}
      heroTitleStyle={styles.heroTitle}
      logoStyle={styles.logo}
      infoCardStyle={styles.infoCard}
      infoItemStyle={styles.infoItem}
      infoLabelStyle={styles.infoLabel}
      primaryBadgeStyle={styles.primaryBadge}
      secondaryBadgeStyle={styles.secondaryBadge}
      badgesContainerStyle={styles.badgesContainer}
      accentBadgeStyle={styles.accentBadge}
      outlineBadgeStyle={styles.outlineBadge}
      overviewSectionStyle={styles.overviewSection}
      overviewGradientStyle={styles.overviewGradient}
      overviewGlowStyle={styles.overviewGlow}
      overviewGridStyle={styles.overviewGrid}
      overviewContentStyle={styles.overviewContent}
      sectionHeaderStyle={styles.sectionHeader}
      accentLineStyle={styles.accentLine}
      sectionTitleStyle={styles.sectionTitle}
      textContainerStyle={styles.textContainer}
      sectionTextStyle={styles.sectionText}
      overviewImageContainerStyle={styles.overviewImageContainer}
      overviewImageWrapperStyle={styles.overviewImageWrapper}
      overviewImageGlowStyle={styles.overviewImageGlow}
      overviewImageStyle={styles.overviewImage}
      approachSectionStyle={styles.approachSection}
      approachGradientStyle={styles.approachGradient}
      approachGlow1Style={styles.approachGlow1}
      approachGlow2Style={styles.approachGlow2}
      approachGridStyle={styles.approachGrid}
      approachContentStyle={styles.approachContent}
      // approachAccentLineStyle={styles.approachAccentLine}
      approachTitleStyle={styles.approachTitle}
      approachTextStyle={styles.approachText}
      scrollAreaStyle={styles.scrollArea}
      scrollContentStyle={styles.scrollContent}
      approachImageWrapperStyle={styles.approachImageWrapper}
      approachImageGlowStyle={styles.approachImageGlow}
      approachImageStyle={styles.approachImage}
    />
  );
};

export default OneTNPage;
